'use strict';

var cache = {};

module.exports = {
    /**
    * Caches the document and add to bag modal elements
    */
    initFilterCache: function () {
        cache.$document = $(document);
        cache.$addToBagModal = $('#addToBagModal');
    },
    /**
    * Filters the Einstein Carousel to remove line items already in the cart
    * @param {Array} lineItemsIDs - an array of line item IDs
    */
    filterCarousel: function (lineItemsIDs) {
        if (!lineItemsIDs) {
            return;
        }

        var $initialSlider = cache.$addToBagModal.find('.js-initial-slider');

        if ($initialSlider.length === 0) {
            return;
        }

        var $carousel = cache.$addToBagModal.find('.js-einstein-jatc-recommendation-slider, .js-jatc-recommendation-slider');
        var $carouselTitle = cache.$addToBagModal.find('.js-carousel-title');
        var slick;

        if ($carousel.length > 0) {
            slick = $carousel[0].slick;
        }

        if (!slick) {
            return;
        }

        $initialSlider.find('.product[data-pid]').parent().removeClass('d-none');

        for (var i = 0; i < lineItemsIDs.length; i++) {
            var productID = lineItemsIDs[i];
            var $initialSliderContainer = $initialSlider.find('.product[data-pid="' + productID + '"]').parent();

            $initialSliderContainer.addClass('d-none');
        }

        var $filteredSlides = $initialSlider.children(':not(.d-none)');

        slick.destroy();

        $carousel.html('');

        for (var j = 0; j < $filteredSlides.length; j++) {
            $carousel.append($($filteredSlides[j]).clone());
        }

        if ($carouselTitle && $filteredSlides.length > 0) {
            $carouselTitle.removeClass('d-none');
        } else {
            $carouselTitle.addClass('d-none');
        }

        cache.$document.trigger('init:initJatcSlider', $carousel);
    },
    /**
    * Handles the events related to the carousel
    */
    filterCarouselEvents: function () {
        var _this = this;

        cache.$document.on('addToBagModal:beforeShowModal', function (e, payload) {
            var cartItems = payload.data.cart.items;
            var lineItemsIDs = [];

            for (var i = 0; i < cartItems.length; i++) {
                lineItemsIDs.push(cartItems[i].id);
            }

            _this.filterCarousel(lineItemsIDs);
        });

        cache.$document.on('miniCart:open', function (e, data) {
            var $linteItemsIDs = $(data).find('[data-lineitem-id');
            var lineItemsIDs = [];

            $linteItemsIDs.each(function (index, element) {
                lineItemsIDs.push($(element).data('lineitem-id'));
            });

            _this.filterCarousel(lineItemsIDs);
        });
    }
};
